// ScheduledCheckInService — migrated to the OpenAPI-generated client.
//
// Preserves each function's pre-migration return shape: getters returned the raw axios
// `response` (callers read `res.data` / `res.data.content`), so we return `{data}` with the
// parsed JSON body. Auth/timezone come from configureApi's interceptor.
//
// NOTE: getScheduledCheckIns's server DTO no longer accepts a `companyId` query param (removed
// in the company-scoping sweep — scope is derived from the principal). We keep the `companyId`
// parameter for caller compatibility but no longer send it.
import {
    adminScheduledCheckInControllerGetScheduledCheckIns,
    adminScheduledCheckInControllerGetById,
    adminScheduledCheckInControllerCreate,
    adminScheduledCheckInControllerUpdate,
    adminScheduledCheckInControllerDelete,
    adminScheduledCheckInControllerToggleActive,
} from '../api/generated';

const throwAsAxiosError = (error, response) => {
    throw {response: {data: error, status: response?.status}};
};

export const getScheduledCheckIns = async (pageId = 0, pageSize = 20, companyId = null) => {
    const {data, error, response} = await adminScheduledCheckInControllerGetScheduledCheckIns({
        query: {pageId, pageSize},
    });
    if (error) throwAsAxiosError(error, response);
    return {data};
};

export const getScheduledCheckInById = async (id) => {
    const {data, error, response} = await adminScheduledCheckInControllerGetById({
        path: {id},
    });
    if (error) throwAsAxiosError(error, response);
    return {data};
};

export const createScheduledCheckIn = async (data) => {
    const {data: resData, error, response} = await adminScheduledCheckInControllerCreate({
        body: data,
    });
    if (error) throwAsAxiosError(error, response);
    return {data: resData};
};

export const updateScheduledCheckIn = async (id, data) => {
    const {data: resData, error, response} = await adminScheduledCheckInControllerUpdate({
        path: {id},
        body: data,
    });
    if (error) throwAsAxiosError(error, response);
    return {data: resData};
};

export const deleteScheduledCheckIn = async (id) => {
    const {data, error, response} = await adminScheduledCheckInControllerDelete({
        path: {id},
    });
    if (error) throwAsAxiosError(error, response);
    return {data};
};

export const toggleScheduledCheckInActive = async (id) => {
    const {data, error, response} = await adminScheduledCheckInControllerToggleActive({
        path: {id},
    });
    if (error) throwAsAxiosError(error, response);
    return {data};
};
